'use strict';

import "@babel/polyfill";
import 'jquery.ripples';

// import { header } from './view/_header';
import { scroll } from './view/_scroll';
import { ripple } from './view/_ripple';
// import { canvas } from './view/_canvas';





